import { checkEmptyFields } from '../utils';
import { EventProperties } from '@lentau/analytics/health-metrics/shared';
import { PaymentTypeInfo } from '@lentau/payment/shared';
import { ReccurentPaymentType } from '@lentau/order/shared/models/payment.model';

export function getPaymentTypesHandler(body: PaymentTypeInfo): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: body?.DefaultPaymentType,
        errorName: 'DefaultPaymentTypeEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function paymentBindingRemoveHandler(body: ReccurentPaymentType[] = []): EventProperties {
  {
    const item: ReccurentPaymentType = body[0];

    const fields = [
      {
        fieldToCheck: item?.Id,
        errorName: 'IdEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function paymentBindingAddHandler(body: string): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: body,
        errorName: 'paymentBindingAddEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}
